import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.385 12c0-4.209 3.406-7.615 7.615-7.615S19.615 7.791 19.615 12 16.209 19.615 12 19.615 4.385 16.209 4.385 12M12 3a9.01 9.01 0 0 0-9 9 9.01 9.01 0 0 0 9 9 9.01 9.01 0 0 0 9-9 9.01 9.01 0 0 0-9-9m0 4.615A4.39 4.39 0 0 0 7.615 12 4.39 4.39 0 0 0 12 16.385 4.39 4.39 0 0 0 16.385 12 4.39 4.39 0 0 0 12 7.615"
    }, null, -1)
  ]))]))
}
export default { render: render }